import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../store";

export const selectDialogId = (state: RootState) => state.global.dialogId;
export const getIsOnline = (state: RootState) => state.global.isOnline;
export const isDialogActive = (id?: string) =>
  createSelector(selectDialogId, (dialogId) => dialogId === id);
